import React from 'react';
import getArticleLink from '../../util/getArticleLink';
import { appContext } from '../../util/decorators';
import externalService from '../../service/external';
import Loader from '../Loader.jsx';

@appContext
export default class FbCommentBox extends React.Component {
  static propTypes = {
    article: React.PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.url = getArticleLink(this.props.article, { href: true });
    this.getTotalCount();
  }

  async getTotalCount() {
    const res = await externalService.getFacebookCount(this.url);
    this.setState({ count: res.comment_count });
  }

  activate() {
    this.setState({ activated: true }, () => {
      const FB = window.FB || null;
      if (FB) FB.XFBML.parse(this.refs.root);
    });
  }

  render() {
    if (this.state.activated) {
      return (
        <div className="fb-comment-box">
          <Loader />
          <div className="fb-comment-content" ref="root">
            <div data-href={this.url} className="fb-comments" data-numposts="5" data-width="100%"></div>
          </div>
        </div>
      );
    }

    return (
      <div className="fb-comment-box">
        <button className="vs-button vs-button-transparent" onClick={() => this.activate()}>
          + {this.context.app.t('FbCommentBox.show_comments')} {this.state.count === undefined ? '' : `(${this.state.count})`}
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/FbCommentBox.jsx